export { default as styled } from './styled';
export type { CSSProperties } from '../CSSProperties';
